import request from '@/utils/request'

// API 路径常量
const API_PATHS = {
  // 用户相关
  USER: {
    LOGIN: '/admin/user/login',
    REGISTER: '/api/userApi/registerUser',
    REGISTER_CODE: '/api/userApi/registerCode',
    FORGOT_PASSWORD: '/api/userApi/forgetPassword',
    RESET_PASSWORD: '/api/userApi/resetPassword',
    CLIENT_LOGIN: '/api/userApi/clientLogin',
    INFO: '/api/userApi/info',
    PAGE: '/admin/user/selectQueryPage',
    CREATE: '/admin/user/save',
    UPDATE: '/admin/user/update',
    DELETE: '/admin/user/delete',
    SELECT: '/admin/user/select',
    SELECT_ALL: '/admin/user/selectAll',
    SELECT_USER_VIP: '/api/userApi/selectUserVip'
  },
  // 系统配置相关
  SYSTEM_CONFIG: {
    GET_CONFIG: '/admin/systemConfig/getConfig',
    UPDATE: '/admin/systemConfig/update',
  },
  // 统计相关
  DASHBOARD: {
    STATISTICS: '/admin/dashboard/statistics',
    PUSH_WEBSITE_VISIT: '/admin/dashboard/pushWebsiteVisitCount'
  },
  // 权限管理相关
  USER_MENU: {
    GET_USER_MENUS: '/admin/userMenu/getUserMenus',
    GET_ALL_MENUS: '/admin/userMenu/getAllMenuInfos'
  }
}

// 用户相关接口
export function login (data) {
  return request({
    url: API_PATHS.USER.LOGIN,
    method: 'post',
    data
  })
}

// 客户端登录（对外入口）
export function clientLogin (data) {
  return request({
    url: API_PATHS.USER.CLIENT_LOGIN,
    method: 'get',
    params: data
  })
}

export function getUserInfo () {
  return request({
    url: API_PATHS.USER.INFO,
    method: 'get'
  })
}

export function register (data) {
  return request({
    url: API_PATHS.USER.REGISTER,
    method: 'post',
    data
  })
}

export function registerCode (email) {
  return request({
    url: API_PATHS.USER.REGISTER_CODE,
    method: 'get',
    params: { email: email }
  })
}

export function forgotPassword (email) {
  return request({
    url: API_PATHS.USER.FORGOT_PASSWORD,
    method: 'get',
    params: { email: email }
  })
}

export function resetPassword (data) {
  return request({
    url: API_PATHS.USER.RESET_PASSWORD,
    method: 'get',
    params: { email: data?.email, code: data?.code, newPassword: data?.newPassword }
  })
}

export function selectUserVip () {
  return request({
    url: API_PATHS.USER.SELECT_USER_VIP,
    method: 'get'
  })
}

// 用户管理接口
export function getUserPage (params) {
  return request({
    url: API_PATHS.USER.PAGE,
    method: 'post',
    data: params
  })
}

export function createUser (data) {
  return request({
    url: API_PATHS.USER.CREATE,
    method: 'post',
    data
  })
}

export function updateUser (data) {
  return request({
    url: API_PATHS.USER.UPDATE,
    method: 'post',
    data
  })
}

export function deleteUser (id) {
  return request({
    url: API_PATHS.USER.DELETE,
    method: 'get',
    params: { id }
  })
}

export function getUserDetail (id) {
  return request({
    url: API_PATHS.USER.SELECT,
    method: 'get',
    params: { id }
  })
}

export function getAllUsers () {
  return request({
    url: API_PATHS.USER.SELECT_ALL,
    method: 'get'
  })
}

// 系统配置接口
export function getSystemConfig () {
  return request({
    url: API_PATHS.SYSTEM_CONFIG.GET_CONFIG,
    method: 'get'
  })
}

export function updateSystemConfig (data) {
  return request({
    url: API_PATHS.SYSTEM_CONFIG.UPDATE,
    method: 'post',
    data
  })
}

export function createSystemConfig (data) {
  return request({
    url: API_PATHS.SYSTEM_CONFIG.SAVE,
    method: 'post',
    data
  })
}

export function deleteSystemConfig (id) {
  return request({
    url: API_PATHS.SYSTEM_CONFIG.DELETE,
    method: 'get',
    params: { id }
  })
}

export function getAllSystemConfigs () {
  return request({
    url: API_PATHS.SYSTEM_CONFIG.SELECT_ALL,
    method: 'get'
  })
}



// 统计相关接口
export function getDashboardData () {
  return request({
    url: API_PATHS.DASHBOARD.STATISTICS,
    method: 'get'
  })
}

export function pushWebsiteVisitCount () {
  return request({
    url: API_PATHS.DASHBOARD.PUSH_WEBSITE_VISIT,
    method: 'post'
  })
}

// 权限管理相关接口
export function getUserMenus (userId) {
  return request({
    url: API_PATHS.USER_MENU.GET_USER_MENUS,
    method: 'get',
    params: { userId }
  })
}

export function getAllMenuInfos () {
  return request({
    url: API_PATHS.USER_MENU.GET_ALL_MENUS,
    method: 'get'
  })
}

